import { State } from './state'

export class Address {
    line1: string
    line2: string
    line3: string
    landmark: string
    city: string
    state: State
    zipcode: string    

    constructor(line1: string, line2: string, line3: string, landmark: string, city: string, state: State, zipcode: string) {
        this.line1 = line1
        this.line2 = line2
        this.line3 = line3
        this.landmark = landmark
        this.city = city
        this.state = state
        this.zipcode = zipcode
    }
}

//SCMT 2.0
// 17-07-2024 NewAddress funtion start

export class NewAddress{
    gstInd: boolean
    state: State
    gstNumber: string
    constructor(gstInd: boolean, state: State, gstNumber: string) {
        this.gstInd = gstInd
        this.state = state
        this.gstNumber = gstNumber
    }
}

// NewAddress funtion end